export default __webpack_public_path__ + "static/media/covid.d1030b1d.png";